export const voucherPrefixes = {
    upgrade: 'UPGRADE',
    infinity: 'INFINITY',
}